import { render, staticRenderFns } from "./SelectionResultLabelPanel.vue?vue&type=template&id=92dfd5a6&scoped=true"
import script from "./SelectionResultLabelPanel.vue?vue&type=script&lang=ts"
export * from "./SelectionResultLabelPanel.vue?vue&type=script&lang=ts"
import style0 from "./SelectionResultLabelPanel.vue?vue&type=style&index=0&id=92dfd5a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92dfd5a6",
  null
  
)

export default component.exports